import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import Router from '@ember/routing/router';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { AdminUserAddRouteModel } from 'donor-elf-web/routes/admin/users/add';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validatePresence } from 'ember-changeset-validations/validators';

let referredByValidation = {
  referredByFirstName: validatePresence(true),
  referredByLastName: validatePresence(true),
};

export default class AdminUserAddReferredByController extends Controller {
  @service declare router: Router;
  @service declare store: Store;

  model!: AdminUserAddRouteModel;

  referralChangeset: any;
  @tracked unanswered = true;
  @tracked showValidationErrors = false;

  @action
  templateWillDestroy() {
    this.referralChangeset = undefined;
    this.unanswered = true;
    this.showValidationErrors = false;
  }

  @action
  handleYesClicked() {
    this.unanswered = false;
    this.referralChangeset = new Changeset(
      {},
      lookupValidator(referredByValidation),
      referredByValidation,
    );
  }

  @action
  async save() {
    await this.referralChangeset.validate();
    if (this.referralChangeset.get('isValid')) {
      this.model.changeset.set(
        'referredByFirstName',
        this.referralChangeset.get('referredByFirstName'),
      );
      this.model.changeset.set(
        'referredByLastName',
        this.referralChangeset.get('referredByLastName'),
      );
      this.model.changeset.set(
        'referredByEmail',
        this.referralChangeset.get('referredByEmail'),
      );
      this.model.changeset.set(
        'referredByOrganizationName',
        this.referralChangeset.get('referredByOrganizationName'),
      );
      this.router.transitionTo('admin.users.add.funds');
    } else {
      this.showValidationErrors = true;
    }
  }
}
